import getRoleProperty from '../getRoleProperty';

class ContactRoleNamedInsured {
    constructor() {
        this.$onInit = () => {
            const {fieldValueGetter} = getRoleProperty(this.roleType, this.roleModel, 'ownerOfficer', 'policyOwnerOfficer');
            const relationshipTitle = fieldValueGetter('relationshipTitle');
            if (relationshipTitle) this.relationshipTitle = relationshipTitle.name;

            const inclusion = fieldValueGetter(undefined, 'include');
            if (inclusion) this.inclusion = inclusion.name;

            const state = fieldValueGetter(undefined, 'state');
            if (state) this.state = state.name;

            this.classCode = fieldValueGetter(undefined, 'classCode');
            this.ownershipPercentage = fieldValueGetter(undefined, 'ownershipPercentage');

            const policyRelationship = fieldValueGetter(undefined, 'policyRelationship');
            if (policyRelationship) this.policyRelationship = policyRelationship.name;
        };
    }
}

export default ContactRoleNamedInsured;